export enum AuthBroadcastMessages {
  LOGOUT = 'logout'
}

interface LogoutBroadcastMessage {
  type: AuthBroadcastMessages.LOGOUT
}

export type AuthBroadcastMessage = LogoutBroadcastMessage
